import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { get } from "../../../service/api";
import { IListDetailsDto } from "../interface/dto/list-details.dto";

export const getListDetails = (
    listId: number,
    tokens: ITokenPair,
): Observable<IListDetailsDto | undefined> =>
    get<IListDetailsDto>(`/lists/details/${listId}`, undefined, tokens);
